module.exports = __webpack_public_path__ + "static/media/freebsd.19ae3735.svg";